import React from 'react';
import { CTAButton } from './ui/CTAButton';
export function HeroSection() {
  return <section className="relative overflow-hidden bg-gradient-to-b from-brand-cream to-[#FFF5E6] py-16 md:py-24" data-id="element-54">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-55">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-56">
          {/* Text Content */}
          <div className="text-center lg:text-left order-2 lg:order-1" data-id="element-57">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-brand-brown leading-tight mb-6" data-id="element-58">
              Dile adiós al pánico del domingo por la noche y recupera tus
              mañanas por <span className="text-brand-coral" data-id="element-59">solo $6.39</span>
            </h1>

            <p className="text-lg md:text-xl text-brand-brown/80 mb-10 max-w-2xl mx-auto lg:mx-0 font-medium" data-id="element-60">
              El sistema de 10 minutos diseñado para mamás latinas en EE.UU. que
              quieren loncheras nutritivas sin vivir en la cocina.
            </p>

            <div className="flex flex-col items-center lg:items-start gap-4" data-id="element-61">
              <a href="#oferta" data-id="element-62">
                <CTAButton className="w-full sm:w-auto text-sm sm:text-base md:text-lg" data-id="element-63">
                  ¡SÍ, QUIERO MIS MAÑANAS SIN ESTRÉS!
                </CTAButton>
              </a>
              <p className="text-sm text-brand-brown/60 font-medium" data-id="element-64">
                Descarga inmediata ahora por solo $19 USD.
              </p>
            </div>
          </div>

          {/* Image Content */}
          <div className="order-1 lg:order-2 relative" data-id="element-65">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl transform -rotate-2 hover:rotate-0 transition-transform duration-500 border-8 border-white" data-id="element-66">
              <img src="https://cdn.magicpatterns.com/uploads/5EGF1YVJFubJ5NpEKdWZNn/oficial.png" alt="Mamá preparando lonchera feliz usando El Plan Lonchera Cero Estrés en su tablet" className="w-full h-auto object-cover" data-id="element-67" />
              {/* Decorative elements */}
              <div className="absolute -bottom-4 -right-4 w-24 h-24 bg-brand-yellow rounded-full -z-10 blur-2xl opacity-60" data-id="element-68"></div>
              <div className="absolute -top-4 -left-4 w-32 h-32 bg-brand-coral rounded-full -z-10 blur-3xl opacity-40" data-id="element-69"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Background decorative blob */}
      <div className="absolute top-0 right-0 -translate-y-1/4 translate-x-1/4 w-96 h-96 bg-brand-yellow/10 rounded-full blur-3xl pointer-events-none" data-id="element-70"></div>
    </section>;
}